import {
  createApp
} from 'vue';
import Vant from 'vant';

import App from './App';
import router from './router';
import 'vant/lib/index.css';
import '@/assets/style/vant.less'
import '@/assets/style/common.less'
const app = createApp(App);
app.use(Vant).use(router).mount('#app');